<rt-box [variant]="rtBoxVariant()" padding-tb-small-xx>
  <div
    (click)="onClick($event)"
    class="header"
    layout
    layout-full-width
    layout-space-between
    layout-align-items-center
  >
    <div class="left-content" [class.align-center]="!hasLeftSlotDesc()">
      <div layout layout-align-items-center>
        <ng-content select="[leftSlot]" />

        @if (!collapseDisabled) {
          <rt-icon [name]="isCollapsed() ? 'expand-more' : 'expand-less'" margin-left-small-xx />
        }
      </div>
      <div>
        <ng-content select="[bellowLeftSlot]" />
      </div>
    </div>
    <div class="right-content" layout layout-justify-flex-end margin-left-small-x>
      <ng-content select="[rightSlot]" />
    </div>
  </div>

  @if (!isCollapsed()) {
    @if (hasHeaderDivider) {
      <div margin-lr>
        <rt-divider variant="line light solid" [hasNoMargin]="true" />
      </div>
    }

    <ng-content select="[collapsible]" />
  }
</rt-box>
